import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type PortfolioViewMode = "grid" | "week" | "month";

interface UiState {
  portfolioViewMode: PortfolioViewMode;
}

const initialState: UiState = {
  portfolioViewMode: "grid",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setPortfolioViewMode(state, action: PayloadAction<PortfolioViewMode>) {
      state.portfolioViewMode = action.payload;
    },
  },
});

export const { setPortfolioViewMode } = uiSlice.actions;
export default uiSlice.reducer;
